import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS } from '@/config/api.config';
let _typesCache = null;
export const questionService = {
  async getQuestions(params = {}) {
    return axios.get(`${API_BASE_URL}${API_ENDPOINTS.QUESTIONS.BASE}`, {
      params,
    });
  },

  async createQuestion(payload) {
    return axios.post(
      `${API_BASE_URL}${API_ENDPOINTS.QUESTIONS.BASE}`,
      payload,
    );
  },

  async updateQuestion(id, payload) {
    return axios.patch(
      `${API_BASE_URL}${API_ENDPOINTS.QUESTIONS.BY_ID(id)}`,
      payload,
    );
  },

  async deleteQuestion(id) {
    return axios.delete(`${API_BASE_URL}${API_ENDPOINTS.QUESTIONS.BY_ID(id)}`);
  },

  async getQuestionTypes(force = false) {
    if (!force && _typesCache) return { data: _typesCache };
    const res = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.QUESTIONS.TYPES}`,
    );
    _typesCache = res?.data || [];
    return { data: _typesCache };
  },

  async getQuestionTypesLookup(force = false) {
    const r = await this.getQuestionTypes(force);
    const map = {};
    (r.data || []).forEach((t) => {
      map[String(t.key).toUpperCase()] = t;
    });
    return map;
  },
};
